import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

export const useConnectedQuestionResultIdToFilter = () => useTypedQuery({ queryKey: AppointmentDetailsKeys.connectedQuestionResultIdToFilter, initialData: null }).data;

export const setConnectedQuestionResultIdToFilter = (id: number | null) => typedQueryClient.setQueryData(AppointmentDetailsKeys.connectedQuestionResultIdToFilter, id);
